import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const NotFoundScreen = () => {
    return (_jsx("div", { id: "tw-root", children: _jsxs("div", { id: "tw-main", className: "App container text-center", children: [_jsx("h3", { className: "text-center w-full my-4", children: "Business not found." }), _jsxs("p", { className: "text-center", children: ["If the problem persists, email ", _jsx("a", { href: "mailto:team@withfriends.co", children: "team@withfriends.co" })] })] }) }));
};
export default NotFoundScreen;
